module.exports = __webpack_public_path__ + "img/kitesurf_experto.0ee97f07.jpg";